// extracted by css-extract-rspack-plugin
export default {"unavailable":"News-unavailable_HPS"};